import { Checkbox, Color, Flex, Icon, Spacing, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../../../../../contexts/customerFormContext'

export const PrimaryContactCheckbox = (): ReactElement => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <Flex gap={Spacing.S8} alignItems="center">
      <FormItem
        name="isContactPrimary"
        render={({ field: { value, onChange } }) => (
          <Checkbox checked={value} onChange={onChange}>
            {t('customer_modal.form.company_persons.primary_checkbox.label')}
          </Checkbox>
        )}
      />
      <Tooltip label={t('customer_modal.form.company_persons.primary_checkbox.tooltip')} placement="top">
        <Icon color={Color.Grey300} icon="info" />
      </Tooltip>
    </Flex>
  )
}
